export function cutPhoneNumberPrefix(phoneNumber?: string): undefined | string {
  if (!phoneNumber) {
    return undefined;
  }

  if (phoneNumber.length < 9) {
    return undefined;
  }

  if (phoneNumber.length === 11) {
    return phoneNumber.replace(/\D/g, "").slice(-9);
  }

  if (phoneNumber.startsWith("48")) {
    return phoneNumber.replace(/\D/g, "").slice("48".length);
  }

  return phoneNumber.slice(-9);
}
